import { ModuleType } from '@shared/types/module.type';
import { analytics } from '@shared/utils/segment.utils';
export const handleAnalyticsSearchResult = (keyword: string, search: ModuleType, countResult: number) => {
  analytics.track('Onsite Search Performed', {
    event: 'Onsite Search Performed',
    query: keyword,
    search,
    results_count: countResult
  });
};